import { Login } from 'components/Login';
import { LOGIN_TYPE } from 'utilities';

const ScreenLoginDealerNameAndEmail = () => {
  return <Login loginType={LOGIN_TYPE.DEALER_NAME_AND_EMAIL} />;
};

export default ScreenLoginDealerNameAndEmail;
